import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page } from '../shared';

class ImproveYourSkillsPage extends Component {
  render(){
    return (
      <Page pageClass="improve">
        <div className="page-title">
          <h1>Improve Your Skills</h1>
          <h3>Subheader</h3>
        </div>
        <div className="page-actions">
          <button className="button primary">Primary</button>
          <button className="button grey-button">Secondary</button>
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps, {})(ImproveYourSkillsPage);



// WEBPACK FOOTER //
// ./src/components/improve/index.js